import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import { Set } from 'immutable'
import InviteTeam from 'components/settings/team/InviteTeam'

class InviteUserWizard extends Component {
  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  componentDidMount() {
    return this.app.stores.OrgStore.resetResendInvitationState()
  }

  componentWillUnmount() {
    return this.app.stores.OrgStore.resetResendInvitationState()
  }

  onInviteSlackUsers = (users, scopes) => {
    this.app.actions.SlackTeamActions.sendInvitationsToSlackDM(users, this.props.currentOrg.id, scopes)
  }

  onInviteEmailUsers = (users, scopes) => {
    this.app.actions.OrgActions.inviteEmails(users, this.props.currentOrg.id, scopes)
  }

  getUsersToInvite = () => {
    const { users, slackTeam } = this.props
    const existingEmails = Set(_.values(users).map(user => user.email))
    const existingSlackIds = Set(_.values(users).map(user => user.slackUserId))
    const usersToInvite = slackTeam.filter(user => {
      if (!existingSlackIds.includes(user.slackUserId) && !existingEmails.includes(user.email)){
        return user
      }
    })
    return usersToInvite
  }

  checkEmailInOtherOrgs = (email) => {
    return this.app.stores.UserStore.fetchUserExistenceByEmail(email).toPromise()
  }

  sendNotification = (notification) => {
    this.app.actions.NotificationActions.pushNotification({
      content: notification,
      variant: 'red'
    })
  }

  saveCompanyInfoPatch = (operations, notif) => {
    this.context.app.actions.DefaultEmbedActions.patchDefaultEmbed(
      operations,
      notif
    )
  }

  render() {
    const { 
      onClose, 
      users, 
      gates,
      inviteLabel,
      successCtaCopy, 
      onInviteEmailUsers, 
      onInviteSlackUsers,
      shouldSelectAutofocus,
      showInviteTips
    } = this.props

    return (
      <InviteTeam
        onInviteSlackUsers={onInviteSlackUsers || this.onInviteSlackUsers}
        onInviteEmailUsers={onInviteEmailUsers || this.onInviteEmailUsers}
        shouldSelectAutofocus={shouldSelectAutofocus}
        showInviteTips={showInviteTips}
        checkEmailInOtherOrgs={this.checkEmailInOtherOrgs}
        totalUsers={Object.values(users).length}
        successCtaCopy={successCtaCopy || null}
        inviteLabel={inviteLabel || null}
        sendNotification={this.sendNotification}
        users={this.getUsersToInvite()}
        orgUsers={Object.values(users)}
        onClose={onClose || null}
        gates={gates}
      />
    )
  }
}

const InviteUserWizardContainer = makeDefaultFailedContainer(InviteUserWizard, {
  listenTo: [
    'stores.OrgStore',
    'stores.UserStore',
    'stores.GateStore',
    'stores.SlackTeamStore',
    'stores.OrgSettingsStore',
    'stores.DefaultEmbedStore',
  ],
  fetch: {
    currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    currentOrg() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },
    orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings()
    },
    gates() {
      return this.app.stores.GateStore.getOrFetchGates()
    },
    users() {
      return this.app.stores.UserStore.getOrFetchNonBotUsersForCurrentUserOrg()
    },
    resendInvitationState() {
      return this.app.stores.OrgStore.getResendInvitationState()
    },
    slackTeam() {
      return this.app.stores.SlackTeamStore.getOrFetchSlackTeam()
    },
    patchStatus() {
      return this.app.stores.DefaultEmbedStore.getPatchStatus()
    }
  }
})

export default InviteUserWizardContainer




// WEBPACK FOOTER //
// ./src/scripts/components/InviteUserWizard/index.js